import {userHovercardPath} from '@github-ui/paths'
import {ProfileReference} from '@github-ui/profile-reference'
import {PinIcon} from '@primer/octicons-react'
import {Link} from '@primer/react'

import styles from './PinnedByBadge.module.css'

type PinnedByBadgeProps = {
  pinnedByLogin: string
}

export function PinnedByBadge({pinnedByLogin}: PinnedByBadgeProps) {
  return (
    <span className={styles.PinnedByContainer}>
      {' '}
      &middot;
      <PinIcon size={12} className={styles.PinnedByIcon} /> Pinned by{' '}
      <Link
        href={`/${pinnedByLogin}`}
        data-hovercard-url={userHovercardPath({owner: pinnedByLogin})}
        className={styles.PinnedByLink}
      >
        <ProfileReference login={pinnedByLogin} isAgent={false} />
      </Link>
    </span>
  )
}

try{ PinnedByBadge.displayName ||= 'PinnedByBadge' } catch {}